import { queryParams } from "../../utils/queryParams";

export const AVERAGE_OPTIONS = ["Not selected", "Brand", "User Access"];

export const GROUP_OPTIONS = ["Brand", "Division", "District", "Region"];

export const DEFAULT_GROUP = "Brand";
export const USER_ACCESS = "User Access";
export const API_STORE = "Store";
export const API_NETWORK = "Network";

export const REQUEST_HREF = {
  BASE: `${queryParams.apiVersion}pages/attendance/utilization_chart`
};
